<div class="flex" [ngClass]="styleClass ? styleClass : 'justify-center'">
  @if (value) {
    <span class="link text-ellipsis overflow-hidden">
      @if (isRouterLink) {
        <a
          [routerLink]="[routerLink]"
          [queryParams]="queryParams"
          routerLinkActive="active"
          [matTooltip]="value"
          matTooltipPosition="below"
          >{{ value }}</a
        >
      }
      @if (!isRouterLink) {
        <a [matTooltip]="value" matTooltipPosition="below" (click)="clickHandler(rowData)">{{ value }}</a>
      }
    </span>
  }
  @if (!value) {
    <span class="not-available" [matTooltip]="notAvailable" matTooltipPosition="below">{{
      notAvailable
    }}</span>
  }
</div>
